import * as React from 'react';
export const aspirationSvg = React.forwardRef(function aspirationSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#1165BF',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.065 20.653h3.743l2.767 6.337 2.709.01-10.09-22h-.383L5.72 27l2.71-.01 2.766-6.337h3.743v-2.135h-2.824l3.887-8.444 3.887 8.444h-2.824v2.135Z',
      fill: '#fff',
    }),
  );
});
aspirationSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var aspiration = {
  category: 'brand',
  colorable: false,
  name: 'aspiration',
  svg: aspirationSvg,
};
